<template>
<div class="chapter">
<div class="inner_page">
<div><p style="margin-top:0px; margin-left:0px; margin-right:0px; margin-bottom:0px; text-align:center"><img alt="" src="images/9781607100379.jpg" style="text-align:center;"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?157ac679